import { useState, useEffect } from 'react';
import { LOGO_URL } from '@/lib/constants';
import { publicApi } from '@/lib/api';
import { useContentValue } from '@/contexts/SiteContentContext';
import { ArrowDown } from 'lucide-react';

function HeroBg() {
  const [url, setUrl] = useState('https://customer-assets.emergentagent.com/job_d41bd410-fd28-4a3a-8701-2681031ee91a/artifacts/kx8i07ag_Gemini_Generated_Image_cwy4kgcwy4kgcwy4.png');
  useEffect(() => {
    publicApi.getImages('hero').then(r => {
      const imgs = r.data.images || [];
      if (imgs.length > 0) setUrl(imgs[0].image_url);
    }).catch(() => {});
  }, []);
  return <img src={url} alt="TreffPunkt Café Bar Lounge in Luzern" className="w-full h-full object-cover" />;
}

export default function HeroSection() {
  const c = useContentValue();

  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <HeroBg />
        <div className="hero-gradient absolute inset-0" />
      </div>
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        {/* Visually-hidden H1 for SEO (logo image communicates the brand visually) */}
        <h1 className="sr-only">TreffPunkt Luzern — Café, Bar, Cocktails und Events am Gasshof 2</h1>
        <div className="animate-fade-in-up flex justify-center mb-8">
          <div className="relative">
            <div className="absolute inset-0 bg-black/25 blur-3xl rounded-full scale-125" />
            <img src={LOGO_URL} alt="TreffPunkt Kaffee-Bar Luzern – Logo" data-testid="hero-logo" className="relative h-[300px] sm:h-[420px] lg:h-[500px] w-auto object-contain drop-shadow-[0_4px_40px_rgba(0,0,0,0.6)]" />
          </div>
        </div>
        <p className="animate-fade-in-up delay-300 text-stone-300/90 text-base sm:text-lg max-w-md mx-auto mb-10 font-body leading-relaxed">
          {c('Hero.Tagline', 'Kaffee, Cocktails, Events und Live-Matches — alles an einem Ort.')}
        </p>
        <div className="animate-fade-in-up delay-500 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#karte" data-testid="hero-cta-menu" className="px-8 py-3.5 bg-amber-500 hover:bg-amber-400 text-[#141413] font-semibold text-sm tracking-wide uppercase rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-amber-500/25">Unsere Karte</a>
          <a href="#events" data-testid="hero-cta-events" className="px-8 py-3.5 border border-stone-500/40 hover:border-amber-400/60 text-stone-200 hover:text-amber-400 font-medium text-sm tracking-wide uppercase rounded-full transition-all duration-300">Events entdecken</a>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#erlebnis" data-testid="hero-scroll-down" className="text-stone-500 hover:text-amber-400 transition-colors"><ArrowDown size={20} /></a>
      </div>
    </section>
  );
}
